import React from 'react'
import { css } from 'glamor';
import * as commonstyles from '../common/common.style';
import HeaderTabletSection from '../common/header/header.tablet'
import HeaderSection from '../common/header/header'
import NavBar from '../navbar/navbar'
import * as navigation from '../../configs/navigation';
import FooterSection from '../common/footer/footer';
import * as accessibilityPageStyles from './AccessibilityMain.style';

const AccessibilityMain = () => {
    return (
        <>
            <HeaderTabletSection history={false} />
            <HeaderSection showSearch={false} history={false} />
            <NavBar items={navigation.navInfo} />
            <div className="row">
                <div className="col-md-3 col-lg-3 col-sm-12 col-12">
                </div>
                <div className="col-md-6 col-lg-6 col-sm-12 col-12">
                    <section {...css(accessibilityPageStyles.heading)} role="region" aria-label={"Accessibility of Danske Bank's Digital Services"}>
                        <h1 {...css(commonstyles.H1Left)} style={{ fontSize: '36px' }}>Accessibility of Danske Bank's Digital Services</h1>

                        <div className="col-md-12 col-lg-12 col-sm-12 col-12"  {...css(commonstyles.nopadding)}>
                            <br />
                            <p {...css(accessibilityPageStyles.aboutBankResearchParagraph)}>
                                Danske Bank is committed to complying with accessibility regulations, specifically Act nr 801 of 07/06/2022, Act (2023:254) on the availability of certain products and services, Disability Discrimination Act 1995 (Chapter 50), Equality Act 2010 (Chapter 15), Act on Accessibility Requirements for Certain Products (102/2023).
                            </p>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-12"  {...css(commonstyles.nopadding)}>
                            <br />
                            <p {...css(accessibilityPageStyles.aboutBankResearchParagraph)}>
                                This Accessibility statement was published on 11/09/2024 and last updated on 11/09/2024, providing information about our general compliance level and identified gaps in each of our digital services.
                            </p>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-12"  {...css(commonstyles.nopadding)}>
                            <br />
                            <p {...css(accessibilityPageStyles.aboutBankResearchParagraph)}>
                                We assess our compliance level as fully compliant. Our aim is to adhere to levels A and AA of the Web Content Accessibility Guidelines (WCAG) 2.1, as required by regulations.
                            </p>
                        </div>
                        <h1 {...css(commonstyles.H1Left)} style={{ fontSize: '36px', marginTop: '40px' }}>Accessibility Status for Danske Bank Research website:</h1>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-12"  {...css(commonstyles.nopadding)}>
                            <br />
                            <p {...css(accessibilityPageStyles.aboutBankResearchParagraph)}>
                                The service is not yet fully compliant with the accessibility requirements; the following gaps have been identified:
                            </p>

                            <p {...css(accessibilityPageStyles.documentText)}>
                                <ul style={{ listStyleType: 'disc' }}>
                                    <li>
                                        <b>Documents:</b> Users may find that PDFs linked to our services are fully compliant. We are working to resolve identified gaps, which may cause screen reader errors, such as incorrect reading order as well as undefined link purposes, low contrast, and missing alternative text.
                                        Below, you will find a list of recognized gaps for the documents.
                                    </li>
                                </ul>
                            </p>
                        </div>
                        <h1 {...css(commonstyles.H1Left)} style={{ fontSize: '20px', marginTop: '60px' }}>For feedback/complaints - contacts to regulators, we kindly refer to follow the countries link below. </h1>
                        <p {...css(accessibilityPageStyles.documentText)}>
                            <ul style={{ listStyleType: 'disc', lineHeight: '1.5', marginTop: '20px' }}>
                                <li><a style={{ color: '#2F4F4F' }} target="_blank" href="https://danskebank.fi/en/for-you/customer-service/accessibility">Finnish homepage for Accessibility Feedback and Contact Details</a></li>
                                <li><a style={{ color: '#2F4F4F' }} target="_blank" href="https://danskebank.dk/en/personal/accessibility/accessibility-statement-for-danske-banks-digital-services">Danish homepage for Accessibility Feedback and Contact Details</a></li>
                                <li><a style={{ color: '#2F4F4F' }} target="_blank" href="https://danskebank.se/privat/general/tillgaenglighetsredogoerelse">Swedish homepage for Accessibility Feedback and Contact Details</a></li>
                                <li><a style={{ color: '#2F4F4F' }} target="_blank" href="https://danskebank.co.uk/personal/accessibility-and-site-requirements">Norther Ireland homepage for Accessibility Feedback and Contact Details</a></li>
                                <li><a style={{ color: '#2F4F4F' }} target="_blank" href="https://danskeci.com/london?showoverlay=1">Great Britain homepage for Accessibility Feedback and Contact Details</a></li>
                            </ul>
                        </p>
                    </section>
                </div>
            </div>
            <FooterSection />
        </>
    )
}

export default AccessibilityMain